(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name flyingScheduleReport.controller:FlyingScheduleReportCtrl
   *
   * @description
   *
   */
  angular
    .module('flyingScheduleReport')
    .controller('FlyingScheduleReportCtrl', FlyingScheduleReportCtrl);

  function FlyingScheduleReportCtrl(CommonMasterData,applicationConstants,MessageService,crewScheduleService,$sce) {
    var vm = this;
    vm.ctrlName = 'FlyingScheduleReportCtrl';

    vm.model = {
      searchPanelToggle:true,
      searchCriteria:{
        crewType :null,
        acModel :null,
        rangeStartLocal :null,
        rangeEndLocal :null
      },
      masterList: {
        crewTypeList:[],
        acModelList:[],
        fromDateAfterToDate : false, 
		fromDateFormatInvalid : false,
		toDateFormatInvalid : false
      },
      initialSearchDone:false,
      reportUrl:''
    };

    vm.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
      vm.model.initialSearchDone=false;
    };

    vm.submitSearch = function (params){
      if(isValidSearchParams(params)){
    	  search(params);
      }
    };
    
  //validate search Params
	function isValidSearchParams(params) {
		setDateValidationFlags();
		// if date invalid
		if(vm.model.masterList.fromDateFormatInvalid  || vm.model.masterList.toDateFormatInvalid){
			vm.model.masterList.fromDateAfterToDate = false; 
			return false;
		}else if (istoDateBeforeFromDate()) {
			vm.model.masterList.fromDateAfterToDate = true; 
			return false;
		}else if(params.crewType==null){
			return false;
		} 
		vm.model.masterList.fromDateAfterToDate = false; 
		return true;
	}

    
    vm.changeSearchField = function(searchParams, flag){
    	if(flag === 'fromDate' || flag === 'toDate'){ 
			setDateValidationFlags();				
			if(!!searchParams.rangeStartLocal && !!searchParams.rangeEndLocal 
					&& !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				}else{
					vm.model.masterList.fromDateAfterToDate = false; 
				}
			}			
		}
	}; 
	
	function setDateValidationFlags(){
		//if from date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.rangeStartLocal)){
			vm.model.masterList.fromDateFormatInvalid = true;
			vm.model.masterList.fromDateAfterToDate = false; 
		}else{
			vm.model.masterList.fromDateFormatInvalid = false;
		}
		
		//if to date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.rangeEndLocal)){
			vm.model.masterList.toDateFormatInvalid = true;
			vm.model.masterList.fromDateAfterToDate = false; 
		}else{
			vm.model.masterList.toDateFormatInvalid = false;
		}
	}
	
	function isDateFormatInvalid(date){ 
		if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
			return true;
		}
		return false;
	} 

	// check from date and to date
	function istoDateBeforeFromDate() {
		return moment(vm.model.searchCriteria.rangeEndLocal, "DD/MM/YYYY")
				.isBefore(
						moment(vm.model.searchCriteria.rangeStartLocal,
								"DD/MM/YYYY"));
	}
	;

    function search(params){
      vm.model.searchPanelToggle = false;
      vm.model.initialSearchDone=true;
      vm.model.searchCriteria = params;

      var crewType = params.crewType.crewTypeCode;
      var acModel = (!!params.acModel) ? params.acModel.modelNumber: null;
      var fromDate = params.rangeStartLocal;
      var toDate = params.rangeEndLocal;
      //vm.model.reportUrl ='http://localhost:8090/service.aerolinecrew.report?__report=report/crew_report.rptdesign&crew_type='+crewType+'&crew_base='+base+'&status='+status;
      //MessageService.error('No Data found');
    }

    CommonMasterData.getCrewTypeList(function(crewTypeList){
      vm.model.masterList.crewTypeList = crewTypeList;
    },function () {});

    CommonMasterData.getAircraftTypeList(function (acModelList) {
      vm.model.masterList.acModelList = acModelList;
    }, function () {
    });
  }
}());
